import { gate } from 'hub-http/gates';

// GATES
export const LINE_ITEMS_BULK_PROPERTIES_UPDATE = 'line-items-bulk';
export const TERM_FREQUENCY_VALIDATION_GATE = 'cpq:frontend-term-frequency-validation';
export const GLOBAL_TERMS_GATE = 'cpq:global-terms';
export const GRANULAR_PRODUCT_PERMISSIONS_GATE = 'UserManagement:ProductLibraryAll';
export const AUTOMATED_SALES_TAX_M3_GATE = 'Commerce:AutomatedSalesTax:M3';
export const PRODUCT_BUNDLES_GATE = 'Cpq:Products:ProductBundles';

// V3 GATES - all V3 gate names must be directly passed to the gate function from hub-http/gates
export const SAVING_LINE_ITEMS_AS_PRODUCTS_GATE = gate('commerce:products:LineItemsAsProducts');
export const SKU_COLLISIONS_GATE = gate('commerce:products:skuCollisions');
export const TIERED_PRICING_ALPHA_GATE = gate('Cpq:Products:TiersAlpha');
export const LINE_ITEM_PREVIEW_CHIRP_GATE = gate('commerce:products:LineItemPreviewCHIRP');
export const PRODUCT_BUILDER_GATE = gate('commerce:product:product-builder');
export const PRODUCT_BUILDER_IFRAME_GATE = gate('commerce:products:productCreatorIFrame');
export const CONTRACTS_PRIVATE_BETA_GATE = gate('Commerce:Contracts:PrivateBeta');
export const CPQ_BETA_GATE = gate('commerce:cpq:bse:CPQQuote');
export const ALL_PROPERTIES_PANEL = gate('CRM:Records:AllPropertiesPanel');

// SCOPES
export const PRODUCT_LIBRARY_VIEW_SCOPE = 'inbounddb-product-library-read';
export const PRODUCT_LIBRARY_EDIT_SCOPE = 'inbounddb-product-library-write';